import React from 'react'
import { useSelector } from 'react-redux'
import { Notification } from '../../../../../../../common/notification'
import { getHighlightScore } from '../../../../../store/slice'
import {
  selectBreakdownCompare,
  selectRiskDriversIsAdjust,
  selectRiskDriversNoteAdjust,
} from '../../../../store/slice'
import CompareFilter from './CompareFilter'
import RelativeContributions from './RelativeContributions'
import { RiskDriversTable } from './RiskDriversTable'
import ScoreBreakdown from './ScoreBreakdown'
import styles from './index.module.scss'

const RiskComponentAnalysisContent = ({
  isCompare,
  setIsCompare,
  filterTime = { from: null, to: null },
  setFilterTime,
}) => {
  const riskDriversIsAdjust = useSelector(selectRiskDriversIsAdjust)
  const riskDriversNoteAdjust = useSelector(selectRiskDriversNoteAdjust)
  const { baseData, compareData } = useSelector(selectBreakdownCompare)
  const { riskScore } = useSelector(getHighlightScore())

  return (
    <>
      {riskScore === null || riskScore === undefined ? (
        <div style={{ height: 200 }}>
          <Notification />
        </div>
      ) : (
        <div style={{ padding: 12 }}>
          <CompareFilter
            isCompare={isCompare}
            setIsCompare={setIsCompare}
            filterTime={filterTime}
            setFilterTime={setFilterTime}
          />
          {riskScore === 0 ? (
            <>
              {isCompare &&
              (baseData.filter((item) => item.scoreValue > 0).length ||
                compareData.filter((item) => item.scoreValue > 0).length) ? (
                <>
                  {riskDriversIsAdjust && (
                    <div className={styles.noteAdjust}>
                      {riskDriversNoteAdjust}
                    </div>
                  )}
                  <div className="dFlex gap5 mt2">
                    <div className="w40">
                      <ScoreBreakdown
                        isCompare={isCompare}
                        filterTime={filterTime}
                      />
                      <RelativeContributions />
                    </div>
                    <div className="w60">
                      <RiskDriversTable isCompare={isCompare} />
                    </div>
                  </div>
                </>
              ) : (
                <div
                  className="mt2 dFlex justifyContentCenter alignItemsCenter"
                  style={{ minHeight: 200 }}
                >
                  <Notification isI18n value="riskComponentAnalysis.noData" />
                </div>
              )}
            </>
          ) : (
            <>
              {riskDriversIsAdjust && (
                <div className={styles.noteAdjust}>{riskDriversNoteAdjust}</div>
              )}
              <div className="dFlex gap5 mt2">
                <div className="w40">
                  <ScoreBreakdown
                    isCompare={isCompare}
                    filterTime={filterTime}
                  />
                  <RelativeContributions />
                </div>
                <div className="w60">
                  <RiskDriversTable
                    isCompare={isCompare}
                    filterTime={filterTime}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}

export default RiskComponentAnalysisContent
